import React from 'react';
import { ScrollablePageWrapper } from 'components';
import './AuthorPage.css';

const AuthorPage = () => (
  <ScrollablePageWrapper>
  <div className="author-page">
    <h1>The App</h1>
    <p>
      AutoLexi is an indie language-learning web application focused on learning through reading.
      It is based on the assumption that the user is reading a book in a foreign language and
      using the app as a helper, progressively fetching and storing new information relevant to
      understanding the underlying text. All information is stored for future reference, kept
      portable and well organised, making it easy to review using effective learning and memory
      techniques.
    </p>
    <p>It's very much a work in progress.</p>

    <h1>The Author</h1>
    <p>Hello, my name is Lari and I'm the developer of AutoLexi.</p>
    <p>I've started this project with several goals in mind.</p>
    <img src="/ldl.jpg" alt="Lari" className="author-photo" />
    <p>
      First of all, I've been tinkering with the idea of writing my own language learning app
      for many years. My interest in software engineering, my passion for languages and my
      interest in sci-fi and fantasy books developed hand in hand during my teenage years.
      This project is an attempt to return to those roots and create a (web)app my younger
      self would have loved to use while learning English. At the same time AutoLexi is an app that
      can be tested by my present self while learning German.
    </p>
    <p>
      It is also an attempt to revive the joy of just building things in an age of growing
      uncertainty. With an education in AI and Computer Science and a few good years of experience
      in Software Engineering, it is difficult not to feel conflicted about the effect one has had
      on the other. On one hand AI is and has always been a fascinating field, as it tries to
      automate tasks in ways that have never been done before, by trying and succeeding to mimic
      how a human brain would do it. On the other hand it has proven to advance
      more quickly than most of us imagined, and as a side effect, society as a whole seems
      unprepared.
    </p>
    <img src="/this_is_fine.png" alt="This is fine" className="this-is-fine-photo" />
    <p>
      Stumbling upon a formula for creating something similar to what randomly came about in
      nature might have been the easy part; learning how to live with it could be the difficult one.
    </p>
    <p>
      Lastly, AutoLexi will ultimately serve as a playground for a few quite benign and interesting AI
      and cognitive science ideas. These will not replace any humans, as they would just fill in
      some gaps in functionality that would be difficult or impossible to implement otherwise. (^///^)
    </p>

    <h1>Contact</h1>
    <div className="author-contact">
      <p>Phone: (voicemail only) 0131 564 0576</p>
      <p>Email: support@autolexi.com</p>
    </div>
  </div>
  </ScrollablePageWrapper>
);

export { AuthorPage };
